import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';

export const useProductIdentifier = () => {
  const {prefixedProductId} = useParams<{
    prefixedProductId?: string;
  }>();
  const productId = getEntityIdFromRouteParam(prefixedProductId);

  return productId
    ? {
        $case: 'id' as const,
        id: productId,
      }
    : null;
};
